import { connect } from 'react-redux';
import { goBack, push } from 'redux-first-history';

import LeaseSelectorPage from './LeaseSelector.component';
import { DEFAULT_ERROR } from '@rental-manager/constants/NotificationConstants';
import { saveLeaseId } from '@rental-manager/actions/OnboardingActions';
import { closeNotification, showModalNotification } from '@common/actions/NotificationActions';
import paths from '@rental-manager/pathsManifest';
import { logError } from '@zg-rentals/log-error';

const mapStateToProps = (state, { propertyId }) => {
  const { leasesForProperty } = state.payments.landlord.onboarding[propertyId];

  return {
    leasesForProperty,
    user: state.user,
    currentProperty: state.payments.landlord.property.listingDetails,
    propertyId,
  };
};

const mapDispatchToProps = (dispatch, { baseUrl, propertyId }) => ({
  onSubmit: (leaseId) =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(saveLeaseId({ propertyId, leaseId })))
      .then(() => dispatch(push({ pathname: baseUrl + paths.onboarding.rentAmountPage })))
      .catch((err) => {
        logError({ error: err });
        dispatch(showModalNotification(DEFAULT_ERROR));
        return { error: true };
      }),
  onBack: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(goBack())),
  onClose: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(push(baseUrl + paths.onboarding.exitPaymentSetup))),
});

export default connect(mapStateToProps, mapDispatchToProps)(LeaseSelectorPage);
